import { useQuery, UseQueryResult } from 'react-query';

import { getTokenWithType } from './useAuth';

import { getProcedureNameList } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

async function fetchProcedureList({ account }: TVariables): Promise<TResult> {
  const response = await fetch(getProcedureNameList(account), {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: Array<string>;
  IsSuccess: boolean;
  StatusCode: number;
};

type TVariables = {
  account: number;
};

function useGetProcedureUrlList(
  account: number,
): UseQueryResult<TResult, TError> {
  return useQuery(
    ['get_procedures_url_list', account],
    async () =>
      await fetchProcedureList({
        account,
      }),
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
      enabled: !isNaN(account),
    },
  );
}

export { useGetProcedureUrlList };
